export default {"src":"/_next/static/media/entertain.a62747d9.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};